import styled from "@emotion/styled";
import { lodestarColors } from "@smartsheet/design-tokens";
import { color } from "@smartsheet/design-tokens-react";
import { getInputFieldHeightValue } from "../../../../util/inputFieldBaseProps";
import { formInputTheme } from "../../../textinput/styled/formInputTheme";
const {
  neutralDark20
} = lodestarColors;
export const DatePickerTextInputPlaceholderStyled = styled("div")`
    position: absolute;
    box-sizing: border-box;
    outline: none;

    // This needs to show on top of the input, but not be clickable.
    z-index: 1;
    pointer-events: none;

    font-weight: ${_ref => {
  let {
    themeMode
  } = _ref;
  return formInputTheme.fontWeight(themeMode);
}};
    font-size: ${_ref2 => {
  let {
    themeMode,
    variant
  } = _ref2;
  return variant === "underline" ? formInputTheme.fontSize.underline(themeMode) : formInputTheme.fontSize.box(themeMode);
}};
    padding-top: ${_ref3 => {
  let {
    themeMode,
    inputFieldHeight
  } = _ref3;
  return formInputTheme.placeholderTop[getInputFieldHeightValue(themeMode, inputFieldHeight)](themeMode);
}};
    padding-left: calc(2px + ${_ref4 => {
  let {
    themeMode
  } = _ref4;
  return formInputTheme.padding.default.rest(themeMode);
}}px);

    .sds__user-input {
        color: transparent;
    }

    .sds__format-placeholder {
        color: ${color("color--text--neutral--weak", neutralDark20)};
    }
`;
//# sourceMappingURL=DatePickerTextInputPlaceholderStyled.js.map